import { useState } from "react";
import {
  User,
  Settings,
  Activity,
  Bell,
  LogOut,
  Crown,
  Heart,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface UserDropdownProps {
  user: {
    name?: string;
    email?: string;
  };
  onLogout: () => void;
}

export const UserDropdown = ({ user, onLogout }: UserDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    /* { icon: User, label: "Mi Perfil", action: () => console.log("Profile") }, */
    {
      icon: Settings,
      label: "Preferencias",
      action: () => console.log("Settings"),
    },
    /* { icon: Bell, label: 'Notificaciones', action: () => console.log('Notifications'), badge: 3 },
    { icon: Activity, label: 'Mi Actividad', action: () => console.log('Activity') }, */
  ];

  return (
    <div className="relative">
      <Button
        variant="ghost"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "flex items-center space-x-3 bg-white/90 backdrop-blur-sm rounded-2xl px-4 py-3 border-2 transition-all duration-300 shadow-md hover:shadow-lg",
          isOpen
            ? "border-admin-accent bg-admin-accent/10 scale-105"
            : "border-admin-border hover:border-admin-accent hover:scale-105"
        )}
      >
        <div className="relative">
          <div className="w-10 h-10 bg-admin-accent/20 rounded-full flex items-center justify-center border-2 border-admin-accent/30">
            <Crown className="h-5 w-5 text-admin-accent" />
          </div>
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-admin-success rounded-full border-2 border-white animate-pulse" />
        </div>
        <div className="hidden md:block text-left">
          <p className="text-sm font-bold text-admin-sidebar font-playfair truncate">
            {user?.name || "CEO"}
          </p>
          <p className="text-xs text-admin-textMuted truncate">
            {user?.email || "Administrador"}
          </p>
        </div>
      </Button>

      {isOpen && (
        <>
          {/* Overlay */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown Menu */}
          <div className="absolute top-full right-0 mt-2 w-72 bg-white rounded-2xl shadow-2xl border-2 border-admin-border z-50 overflow-hidden animate-in slide-in-from-top-2 duration-200">
            {/* Header */}
            <div className="bg-gradient-to-r from-admin-accent/20 to-admin-accentLight/20 p-4 border-b border-admin-border">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-admin-accent/30 rounded-full flex items-center justify-center border-2 border-admin-accent">
                  <Heart className="h-6 w-6 text-admin-accent" />
                </div>
                <div>
                  <p className="font-bold text-admin-sidebar font-playfair">
                    {user?.name || "CEO Administrator"}
                  </p>
                  <p className="text-sm text-admin-textMuted">
                    {user?.email || "admin@viviconamoryarte.com"}
                  </p>
                  <div className="flex items-center space-x-1 mt-1">
                    <div className="w-2 h-2 bg-admin-success rounded-full animate-pulse" />
                    <span className="text-xs text-admin-success font-medium">
                      En línea
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="p-2">
              {menuItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => {
                    item.action();
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl hover:bg-admin-accent/10 transition-all duration-200 group"
                >
                  <item.icon className="h-5 w-5 text-admin-textMuted group-hover:text-admin-accent transition-colors" />
                  <span className="flex-1 text-left font-medium text-admin-sidebar group-hover:text-admin-accent">
                    {item.label}
                  </span>
                  {item.badge && (
                    <span className="bg-admin-warning text-admin-sidebar text-xs font-bold px-2 py-1 rounded-full">
                      {item.badge}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Separator */}
            <div className="border-t border-admin-border mx-2" />

            {/* Logout */}
            <div className="p-2">
              <button
                onClick={() => {
                  onLogout();
                  setIsOpen(false);
                }}
                className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl hover:bg-admin-danger/10 transition-all duration-200 group text-admin-danger"
              >
                <LogOut className="h-5 w-5 group-hover:scale-110 transition-transform" />
                <span className="flex-1 text-left font-bold font-playfair">
                  Cerrar Sesión
                </span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
